import {Response, Result} from './models/Response';
import {Media} from '../models/Media';

export class MediaApi {
    public async get(): Promise<Response<Media[]>> {
        try {
            const rawResponse = await fetch('/training/media', {
                method: 'GET',
                headers: {
                    'X-Csrf-Token': (document as any).head.querySelector('meta[name="csrf-token"]').content,
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            const data = await rawResponse.json();

            if (rawResponse.status >= 200 && rawResponse.status < 300) {
                return {
                    result: Result.Success,
                    data: data,
                };
            }
            if (rawResponse.status === 422) {
                const errors: Array<{field: string; error: string}> = [];
                for (const key of Object.keys(data.errors)) {
                    errors.push({
                        field: key,
                        error: data.errors[key][0],
                    });
                }

                return {
                    result: Result.Validation,
                    errors: errors,
                };
            }
            return {
                result: Result.Error,
            };
        } catch (e) {
            return {
                result: Result.Error,
            };
        }
    }
}
